import { useLocation, useNavigate } from "react-router-dom";
import { AppPathWithInquiry } from "../../paths";

export default function useNavigateWithSearch() {
  const { search } = useLocation();
  const navigate = useNavigate();

  return (to: AppPathWithInquiry) => navigate(to + search);
}
